import {
  CommonHelperFunctions,
  EActionCategory,
  EDatasourceType,
  IAction,
  IActionDefinitionDto
} from "@kuika/kuika-cl-model";
import { Guid } from "guid-typescript";

class ActionService {
  static ACTION_BLACKLIST: string[] = [
    "ResumeProcess",
    "SaveStepData",
    "SetValueOf",
    "SetFocusTo",
    "NAVIGATE",
    "ChangeEnabledOf",
    "ChangeVisibilityOf",
    "ToggleVisibilityOf",
    "ToggleMenuCollapse",
    "ToggleHamburgerMenuCollapse",
    "OpenCollapsePanelOf",
    "CloseCollapsePanelOf",
    "ToggleCollapsePanelOf",
    "SendMail",
    "TriggerEvent"
  ];

  public static getIsActionDefinitionUsableForDataOperations(actionDefinition: IActionDefinitionDto): boolean {
    if (!actionDefinition) {
      return false;
    }

    if (ActionService.ACTION_BLACKLIST.includes(actionDefinition.name)) {
      return false;
    }

    if (actionDefinition.isDeprecated) {
      return false;
    }

    if (actionDefinition.actionCategory === EActionCategory.Arithmetic) {
      return false;
    }

    if (actionDefinition.actionCategory === EActionCategory.Condition) {
      return false;
    }

    if (actionDefinition.actionCategory === EActionCategory.Invers) {
      return false;
    }

    if (actionDefinition.actionCategory === EActionCategory.ArrayOperations) {
      return false;
    }

    if (actionDefinition.actionCategory === EActionCategory.StringOperations) {
      return false;
    }

    if (actionDefinition.actionCategory === EActionCategory.Device) {
      return false;
    }

    if (actionDefinition.actionCategory === EActionCategory.Export) {
      return false;
    }

    if (actionDefinition.actionCategory === EActionCategory.MultiLanguage) {
      return false;
    }

    if (actionDefinition.actionCategory === EActionCategory.UIControl) {
      return false;
    }

    if (
      actionDefinition.actionCategory === EActionCategory.Other &&
      actionDefinition.actionType === EDatasourceType.SystemJSFunctions
    ) {
      return false;
    }

    return (
      ActionService.getIsActionHaveInputs(actionDefinition) || ActionService.getIsActionHaveOutputs(actionDefinition)
    );
  }

  public static getIsActionHaveInputs(actionDefinition: IActionDefinitionDto): boolean {
    return actionDefinition.actionParameters?.length > 0;
  }

  public static getIsActionHaveOutputs(actionDefinition: IActionDefinitionDto): boolean {
    return !CommonHelperFunctions.getIsTypeSimpleKuikaPrimitive(actionDefinition.returnTypeName);
  }

  static setNewIdsForAction = (action: IAction) => {
    action.id = Guid.create().toString();

    action.ifThenElseData?.ifActions?.forEach((ifAction: IAction) => {
      this.setNewIdsForAction(ifAction);
    });

    action.ifThenElseData?.elseActions?.forEach((thenAction: IAction) => {
      this.setNewIdsForAction(thenAction);
    });

    action.recurringActionsData?.recurringActions?.forEach((recurringAction: IAction) => {
      this.setNewIdsForAction(recurringAction);
    });

    action.forEachData?.actions?.forEach((forEachAction: IAction) => {
      this.setNewIdsForAction(forEachAction);
    });

    action.mqttSubscribeActionData?.mqttSubscribeActions?.forEach((mqttSubscribeAction: IAction) => {
      this.setNewIdsForAction(mqttSubscribeAction);
    });
  };
}

export default ActionService;
